'use client';

import PRODUCTPAGE from '@/views/product/content';

export default PRODUCTPAGE;
